import { Kb3dModel } from '../decorators/kb3d-decorator';
import { ISubdivisionFeature } from '../kb3d-models';
import { KbVector } from '../primitives/kb-vector';
import { Token } from '../token';
import { ALL_GEOMETRY, Feature } from './feature';

@Kb3dModel({
    token: Token.SubdivisionFeature,
})
export class SubdivisionFeature extends Feature implements ISubdivisionFeature {
    static _affectedBy = new Set(ALL_GEOMETRY);
    static _affects = new Set(ALL_GEOMETRY);

    subdivisionLevel: number = 1;
}